import './App.css';
import Header from './com/header/header';
import Home from "./com/home page/home"
import Footer from "./com/footer/footer"
import Tours from "./com/tours/tours"
import Gallery from './com/gallery/gallery';
import About from './com/aboutus/aboutus'
import Contactus from "./com/contactus/contactus"
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ScrollToTop, ScrollToHash } from "./com/settings/settings";
import Inquery from "./com/inquery/inquery"
import { LanguageProvider } from "./com/settings/LanguageContext";
import TourPage from "./com/tourpackage/turpackage"
import WhatsappButton from "./com/wpbut/wpbutton";
import ScrollToTopButton  from "./com/settings/upbut"


function App() {
  return (
    <LanguageProvider>  {/* Wrap everything inside LanguageProvider */}
      <BrowserRouter>
        <ScrollToTop />
        <ScrollToHash />
        <div className="App">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path='/tours' element={<Tours />} />
            <Route path='/gallery' element={<Gallery />} />
            <Route path='/about' element={<About />} />
            <Route path='/contactus' element={<Contactus />} />
            <Route path='/inquery' element={<Inquery />}/>
            <Route path="/tour/:id" element={<TourPage />} />

          </Routes>
          <Footer /> 
          <ScrollToTopButton />
          <WhatsappButton />
        </div>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;